





















































































































import { Button } from 'element-ui'
import { Component, Vue } from 'vue-property-decorator'
import { Location, Route } from 'vue-router'

import AuthModal from '@/components/AuthModal.vue'
import CustomerWidget from '@/components/CustomerWidget.vue'
import InlineCustomerWidget from '@/components/InlineCustomerWidget.vue'
import LoginForm from '@/components/LoginForm.vue'
import RegistrationForm from '@/components/RegistrationForm.vue'

import Customer from '@/models/customer'
import Invitation from '@/models/invitation'
import LoginCredentials from '@/models/login-credentials'
import Passenger from '@/models/passenger'
import RegistrationData from '@/models/registration-data'

import EventBus from '@/event-bus'
import store from '@/store'
import { AuthActionTypes } from '@/store/modules/auth/actions'
import { InvitePageActionTypes } from '@/store/modules/invitePage'
import { ProfileDataActionTypes } from '@/store/modules/profileData'

@Component({
  components: {
    AuthModal,
    CustomerWidget,
    InlineCustomerWidget,
    LoginForm,
    RegistrationForm,
    [Button.name]: Button,
  },
})
export default class InvitePage extends Vue {
  currentForm = 'sign-up'
  isLogined = false

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: Location) => void,
  ) {
    store.dispatch(ProfileDataActionTypes.LoadNationalities)
    store.dispatch(ProfileDataActionTypes.LoadCountries)
    await store.dispatch(
      InvitePageActionTypes.GetInvitation,
      to.params.autologinToken,
    )

    next()
  }

  created() {
    this.isLogined = this.$store.getters.isLogined
    if (this.invitedCustomer) {
      this.currentForm = 'sign-in'
    }
  }

  mounted() {
    this.onInvitationLoad()
  }

  get errors() {
    return this.$store.getters.getRegistrationPageErrors
  }

  get formPending() {
    return false
  }

  get invitation(): Invitation {
    return this.$store.getters.getInvitationPageInvitation
  }

  get leadCustomer(): Customer | null {
    return this.$store.getters.getCustomerById(this.invitation.customerId)
  }

  get invitedCustomer(): Customer | null {
    return this.$store.getters.getCustomerById(
      this.invitation.invitedCustomerId,
    )
  }

  get currentCustomer(): Customer | null {
    return this.$store.getters.getCurrentCustomer
  }

  get error() {
    return this.$store.getters.getLoginPageError
  }

  get currentCustomerInvited(): boolean {
    if (!this.currentCustomer || !this.invitedCustomer) {
      return false
    }

    return this.currentCustomer.email === this.invitedCustomer.email
  }

  get redirectTo(): string {
    return `/bookings/${this.passenger.bookingId}`
  }

  get passenger(): Passenger {
    return this.$store.getters.getInvitationPagePassenger
  }

  get backgroundImageStyleObject(): { backgroundImage: string } {
    return {
      backgroundImage: `url(${this.invitation.backgroundImageUrl})`,
    }
  }

  onInvitationLoad() {
    if (this.invitation.backgroundImageUrl) {
      EventBus.$emit('set-layout-background', this.backgroundImageStyleObject)
    }
  }

  goToSignUp() {
    this.currentForm = 'sign-up'
  }

  goToSignIn() {
    this.currentForm = 'sign-in'
  }

  async onRegistration(registrationData: RegistrationData) {
    await this.$store.dispatch(AuthActionTypes.Registration, {
      registrationData,
    })
    this.resolveInvitation(true)
  }

  async onLogin(credentials: LoginCredentials) {
    await this.$store.dispatch(AuthActionTypes.Login, { credentials })
    this.resolveInvitation()
  }

  async resolveInvitation(isNewCustomer?: boolean) {
    await this.$store.dispatch(
      InvitePageActionTypes.GetInvitation,
      this.invitation.autologinToken,
    )
    if (this.invitation.expired) {
      window.location.reload()
    } else if (this.$store.getters.isLogined) {
      this.$store.dispatch(InvitePageActionTypes.ResolveInvitation, {
        redirectTo: this.redirectTo,
        isNewCustomer,
      })
    }
  }

  logOut() {
    this.currentForm = 'sign-in'
    this.isLogined = false
    this.$store.dispatch(AuthActionTypes.Logout, {})
    this.goToSignIn()
  }
}
